/* iv-cart-delivery.js (2026-08-26)
   Zet de levertijd van de winkelwagen als cart-attributen, zodat een checkout-app
   Klarna kan verbergen bij een lange levertijd (Mehmet 26/08). Zie
   snippets/iv-cart-delivery.liquid voor de bron van de gegevens.

   Werkwijze: lees het JSON-blok dat Liquid rendert, bepaal het hoogste aantal dagen
   in de winkelwagen, en schrijf alleen weg als de uitkomst afwijkt van wat er al
   staat. Zonder die vergelijking zou elke paginalading een cart-update doen.
   Na een wijziging in de winkelwagen (cart:refresh / cart:updated) halen we de
   verse regels op bij /cart.js, want het JSON-blok is dan verouderd. */
(function () {
  var BEZIG = false;

  function dagenUit(tekst) {
    if (typeof tekst !== 'string' || !tekst) return 0;
    // Hoogste getal in de tekst: "1-5 business days" -> 5, "2 tot 4 weken" -> 4 (weken
    // rekenen we hieronder om). Losse jaartallen komen in een levertijdtekst niet voor.
    var getallen = (tekst.match(/\d+/g) || []).map(Number);
    if (!getallen.length) return 0;
    var max = Math.max.apply(null, getallen);
    if (/week|weken/i.test(tekst)) max = max * 5;      // werkweken
    else if (/maand|month/i.test(tekst)) max = max * 20;
    return max;
  }

  function bepaal(regels, drempel) {
    var max = 0;
    (regels || []).forEach(function (t) {
      var d = dagenUit(t);
      if (d > max) max = d;
    });
    return { days: max, speed: max > drempel ? 'slow' : 'fast' };
  }

  function schrijf(uitkomst) {
    if (BEZIG) return;
    BEZIG = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _delivery_speed: uitkomst.days ? uitkomst.speed : '',
          _delivery_days: uitkomst.days ? String(uitkomst.days) : ''
        }
      })
    }).catch(function () { /* stil: dit is een label, geen koopstap */ })
      .then(function () { BEZIG = false; });
  }

  function verwerk(regels, huidig, drempel) {
    var uit = bepaal(regels, drempel);
    var speed = uit.days ? uit.speed : '';
    var days = uit.days ? String(uit.days) : '';
    if ((huidig.speed || '') === speed && (huidig.days || '') === days) return;
    schrijf(uit);
  }

  function uitBlok() {
    var el = document.querySelector('[data-iv-cart-delivery]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function start() {
    var data = uitBlok();
    if (!data) return;
    verwerk(data.regels, data.huidig || {}, data.drempel || 5);
  }

  /* Na een cart-wijziging is het JSON-blok van de paginalading verouderd (QA 26/08:
     add-to-cart vanaf de pdp naar de winkelwagen-la bereikte de checkout zonder label).
     Daarom halen we de sectie opnieuw op via de Section Rendering API; die rendert de
     regels van de VERSE winkelwagen. */
  function opnieuw() {
    fetch('/?section_id=iv-cart-delivery', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-iv-cart-delivery]');
        if (!el) return;
        var data = JSON.parse(el.textContent);
        verwerk(data.regels, data.huidig || {}, data.drempel || 5);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('cart:refresh', opnieuw);
  document.addEventListener('cart:updated', opnieuw);
})();
